import { render, staticRenderFns } from "./AddNewPayService.vue?vue&type=template&id=756604bd&scoped=true"
import script from "./AddNewPayService.vue?vue&type=script&lang=ts"
export * from "./AddNewPayService.vue?vue&type=script&lang=ts"
import style0 from "./AddNewPayService.vue?vue&type=style&index=0&id=756604bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756604bd",
  null
  
)

export default component.exports